import mitt from 'mitt';

// eslint-disable-next-line no-shadow
export enum NOTIFICATION {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  INFO = 'INFO',
}

interface INotificationEvent {
  message: string;
  showNotification?: boolean;
  permanent?: boolean;
}

type IHandler = (event: INotificationEvent) => void;

interface IEmitter {
  emit(type: NOTIFICATION, event: INotificationEvent): void;

  emit(type: NOTIFICATION): void;

  on(type: NOTIFICATION, handler: IHandler): void;
}

const Bus: IEmitter = mitt();

export default Bus;
